export default {
      id: "quote-64-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "assets/iconset.svg#quote-64",
      toString: function () {
        return this.url;
      }
    }